var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPpcTable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: 270.551,
    viewBox: "0 0 331 270.551",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3119",
    "data-name": "Group 3119",
    transform: "translate(-92 -3067)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2083",
    "data-name": "Rectangle 2083",
    width: 244.838,
    height: 252.548,
    transform: "translate(92.162 3067)",
    fill: "#f8f8f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2084",
    "data-name": "Rectangle 2084",
    width: 74.838,
    height: 252.548,
    transform: "translate(347.581 3067)",
    fill: "#f8f8f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_322",
    "data-name": "Line 322",
    x2: 244.974,
    transform: "translate(92.026 3107.81)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_323",
    "data-name": "Line 323",
    x2: 74.393,
    transform: "translate(347.607 3107.81)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_324",
    "data-name": "Line 324",
    x2: 244.974,
    transform: "translate(92.026 3127.01)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_325",
    "data-name": "Line 325",
    x2: 74.393,
    transform: "translate(347.607 3127.01)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_326",
    "data-name": "Line 326",
    x2: 244.974,
    transform: "translate(92.026 3146.209)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_327",
    "data-name": "Line 327",
    x2: 74.393,
    transform: "translate(347.607 3146.209)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_328",
    "data-name": "Line 328",
    x2: 244.974,
    transform: "translate(92.026 3165.408)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_329",
    "data-name": "Line 329",
    x2: 74.393,
    transform: "translate(347.607 3165.408)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_330",
    "data-name": "Line 330",
    x2: 244.974,
    transform: "translate(92 3184.608)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_331",
    "data-name": "Line 331",
    x2: 74.393,
    transform: "translate(347.581 3184.608)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_332",
    "data-name": "Line 332",
    x2: 244.974,
    transform: "translate(92.026 3203.807)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_333",
    "data-name": "Line 333",
    x2: 74.393,
    transform: "translate(347.607 3203.807)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_334",
    "data-name": "Line 334",
    x2: 244.974,
    transform: "translate(92.026 3223.007)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_335",
    "data-name": "Line 335",
    x2: 74.393,
    transform: "translate(347.607 3223.007)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_336",
    "data-name": "Line 336",
    x2: 244.974,
    transform: "translate(92.026 3242.206)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_337",
    "data-name": "Line 337",
    x2: 74.393,
    transform: "translate(347.607 3242.206)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_338",
    "data-name": "Line 338",
    x2: 244.974,
    transform: "translate(92.026 3261.406)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_339",
    "data-name": "Line 339",
    x2: 74.393,
    transform: "translate(347.607 3261.406)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_340",
    "data-name": "Line 340",
    x2: 244.974,
    transform: "translate(92.026 3280.605)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_341",
    "data-name": "Line 341",
    x2: 74.393,
    transform: "translate(347.607 3280.605)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_342",
    "data-name": "Line 342",
    x2: 244.974,
    transform: "translate(92.026 3299.804)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_343",
    "data-name": "Line 343",
    x2: 74.393,
    transform: "translate(347.607 3299.804)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_763",
    "data-name": "Path 763",
    d: "M0,0H244.974",
    transform: "translate(92.026 3319.548)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_764",
    "data-name": "Path 764",
    d: "M0,0H74.419",
    transform: "translate(347.581 3319.548)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_344",
    "data-name": "Line 344",
    x2: 244.974,
    transform: "translate(92.026 3088.611)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_345",
    "data-name": "Line 345",
    x2: 74.419,
    transform: "translate(347.581 3088.611)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    id: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec_Avg.",
    "data-name": "Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec Avg.",
    transform: "translate(124 3101.181)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -19.77,
    y: 0
  }, "Jan"), /*#__PURE__*/React.createElement("tspan", {
    x: -19.723,
    y: 19.4
  }, "Feb"), /*#__PURE__*/React.createElement("tspan", {
    x: -21.064,
    y: 38.8
  }, "Mar"), /*#__PURE__*/React.createElement("tspan", {
    x: -18.621,
    y: 58.2
  }, "Apr"), /*#__PURE__*/React.createElement("tspan", {
    x: -22.682,
    y: 77.6
  }, "May"), /*#__PURE__*/React.createElement("tspan", {
    x: -19.857,
    y: 97
  }, "Jun"), /*#__PURE__*/React.createElement("tspan", {
    x: -16.148,
    y: 116.4
  }, "Jul"), /*#__PURE__*/React.createElement("tspan", {
    x: -21.111,
    y: 135.8
  }, "Aug"), /*#__PURE__*/React.createElement("tspan", {
    x: -20.209,
    y: 155.2
  }, "Sep"), /*#__PURE__*/React.createElement("tspan", {
    x: -18.451,
    y: 174.6
  }, "Oct"), /*#__PURE__*/React.createElement("tspan", {
    x: -21.123,
    y: 194
  }, "Nov"), /*#__PURE__*/React.createElement("tspan", {
    x: -20.508,
    y: 213.4
  }, "Dec"), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -24.182,
    y: 232.8
  }, "Avg."))), /*#__PURE__*/React.createElement("text", {
    id: "Cost_Per_click",
    "data-name": "Cost Per click",
    transform: "translate(385 3082.351)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -37.365,
    y: 0
  }, "Cost Per click")), /*#__PURE__*/React.createElement("text", {
    id: "_2_283_2_150_1_894_1_904_1_674_1_064_1_498_1_862_1_632_2_239_2_131_779_512",
    "data-name": "2,283 2,150 1,894 1,904 1,674 1,064 1,498 1,862 1,632 2,239 2,131 779 512",
    transform: "translate(216.32 3101.551)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -14.654,
    y: 0
  }, "2,283"), /*#__PURE__*/React.createElement("tspan", {
    x: -14.654,
    y: 19.4
  }, "2,150"), /*#__PURE__*/React.createElement("tspan", {
    x: -14.654,
    y: 38.8
  }, "1,894"), /*#__PURE__*/React.createElement("tspan", {
    x: -14.654,
    y: 58.2
  }, "1,904"), /*#__PURE__*/React.createElement("tspan", {
    x: -14.654,
    y: 77.6
  }, "1,674"), /*#__PURE__*/React.createElement("tspan", {
    x: -14.654,
    y: 97
  }, "1,064"), /*#__PURE__*/React.createElement("tspan", {
    x: -14.654,
    y: 116.4
  }, "1,498"), /*#__PURE__*/React.createElement("tspan", {
    x: -14.654,
    y: 135.8
  }, "1,862"), /*#__PURE__*/React.createElement("tspan", {
    x: -14.654,
    y: 155.2
  }, "1,632"), /*#__PURE__*/React.createElement("tspan", {
    x: -14.654,
    y: 174.6
  }, "2,239"), /*#__PURE__*/React.createElement("tspan", {
    x: -14.654,
    y: 194
  }, "2,131"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.107,
    y: 213.4
  }, "779"), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -10.327,
    y: 232.8
  }, "512"))), /*#__PURE__*/React.createElement("text", {
    id: "Views",
    transform: "translate(216 3082.351)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -16.251,
    y: 0
  }, "Views")), /*#__PURE__*/React.createElement("text", {
    id: "_170_243_163_187_174_87_126_168_164_197_188_80_512",
    "data-name": "170 243 163 187 174 87 126 168 164 197 188 80 512",
    transform: "translate(265.32 3101.551)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -10.107,
    y: 0
  }, "170"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.107,
    y: 19.4
  }, "243"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.107,
    y: 38.8
  }, "163"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.107,
    y: 58.2
  }, "187"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.107,
    y: 77.6
  }, "174"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 97
  }, "87"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.107,
    y: 116.4
  }, "126"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.107,
    y: 135.8
  }, "168"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.107,
    y: 155.2
  }, "164"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.107,
    y: 174.6
  }, "197"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.107,
    y: 194
  }, "188"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 213.4
  }, "80"), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -10.327,
    y: 232.8
  }, "512"))), /*#__PURE__*/React.createElement("text", {
    id: "Clicks",
    transform: "translate(265 3082.351)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -16.526,
    y: 0
  }, "Clicks")), /*#__PURE__*/React.createElement("text", {
    id: "_7_11_9_10_10_8_8_9_10_9_9_10_25_",
    "data-name": "7% 11% 9% 10% 10% 8% 8% 9% 10% 9% 9% 10% 25%",
    transform: "translate(314.32 3101.551)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7.764,
    y: 0
  }, "7%"), /*#__PURE__*/React.createElement("tspan", {
    x: -11.133,
    y: 19.4
  }, "11%"), /*#__PURE__*/React.createElement("tspan", {
    x: -7.764,
    y: 38.8
  }, "9%"), /*#__PURE__*/React.createElement("tspan", {
    x: -11.133,
    y: 58.2
  }, "10%"), /*#__PURE__*/React.createElement("tspan", {
    x: -11.133,
    y: 77.6
  }, "10%"), /*#__PURE__*/React.createElement("tspan", {
    x: -7.764,
    y: 97
  }, "8%"), /*#__PURE__*/React.createElement("tspan", {
    x: -7.764,
    y: 116.4
  }, "8%"), /*#__PURE__*/React.createElement("tspan", {
    x: -7.764,
    y: 135.8
  }, "9%"), /*#__PURE__*/React.createElement("tspan", {
    x: -11.133,
    y: 155.2
  }, "10%"), /*#__PURE__*/React.createElement("tspan", {
    x: -7.764,
    y: 174.6
  }, "9%"), /*#__PURE__*/React.createElement("tspan", {
    x: -7.764,
    y: 194
  }, "9%"), /*#__PURE__*/React.createElement("tspan", {
    x: -11.133,
    y: 213.4
  }, "10%"), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.314,
    y: 232.8
  }, "25%"))), /*#__PURE__*/React.createElement("text", {
    id: "Rate",
    transform: "translate(314 3082.351)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.316,
    y: 0
  }, "Rate")), /*#__PURE__*/React.createElement("text", {
    id: "Budget",
    transform: "translate(163 3082.351)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -19.263,
    y: 0
  }, "Budget")), /*#__PURE__*/React.createElement("text", {
    id: "_533_580_464_491_530_422_528_506_475_523_490_214_480",
    "data-name": "$533 $580 $464 $491 $530 $422 $528 $506 $475 $523 $490 $214 $480",
    transform: "translate(163.567 3101.547)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.477,
    y: 0
  }, "$533"), /*#__PURE__*/React.createElement("tspan", {
    x: -13.477,
    y: 19.4
  }, "$580"), /*#__PURE__*/React.createElement("tspan", {
    x: -13.477,
    y: 38.8
  }, "$464"), /*#__PURE__*/React.createElement("tspan", {
    x: -13.477,
    y: 58.2
  }, "$491"), /*#__PURE__*/React.createElement("tspan", {
    x: -13.477,
    y: 77.6
  }, "$530"), /*#__PURE__*/React.createElement("tspan", {
    x: -13.477,
    y: 97
  }, "$422"), /*#__PURE__*/React.createElement("tspan", {
    x: -13.477,
    y: 116.4
  }, "$528"), /*#__PURE__*/React.createElement("tspan", {
    x: -13.477,
    y: 135.8
  }, "$506"), /*#__PURE__*/React.createElement("tspan", {
    x: -13.477,
    y: 155.2
  }, "$475"), /*#__PURE__*/React.createElement("tspan", {
    x: -13.477,
    y: 174.6
  }, "$523"), /*#__PURE__*/React.createElement("tspan", {
    x: -13.477,
    y: 194
  }, "$490"), /*#__PURE__*/React.createElement("tspan", {
    x: -13.477,
    y: 213.4
  }, "$214"), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.77,
    y: 232.8
  }, "$480"))), /*#__PURE__*/React.createElement("text", {
    id: "_3.13_2.39_2.84_2.63_3.05_4.85_4.19_3.01_2.89_2.65_2.61_2.67_2.96",
    "data-name": "$3.13 $2.39 $2.84 $2.63 $3.05 $4.85 $4.19 $3.01 $2.89 $2.65 $2.61 $2.67 $2.96",
    transform: "translate(385.567 3101.547)",
    fill: "#329998",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -15.056,
    y: 0
  }, "$3.13"), /*#__PURE__*/React.createElement("tspan", {
    x: -15.056,
    y: 19.4
  }, "$2.39"), /*#__PURE__*/React.createElement("tspan", {
    x: -15.056,
    y: 38.8
  }, "$2.84"), /*#__PURE__*/React.createElement("tspan", {
    x: -15.056,
    y: 58.2
  }, "$2.63"), /*#__PURE__*/React.createElement("tspan", {
    x: -15.056,
    y: 77.6
  }, "$3.05"), /*#__PURE__*/React.createElement("tspan", {
    x: -15.056,
    y: 97
  }, "$4.85"), /*#__PURE__*/React.createElement("tspan", {
    x: -15.056,
    y: 116.4
  }, "$4.19"), /*#__PURE__*/React.createElement("tspan", {
    x: -15.056,
    y: 135.8
  }, "$3.01"), /*#__PURE__*/React.createElement("tspan", {
    x: -15.056,
    y: 155.2
  }, "$2.89"), /*#__PURE__*/React.createElement("tspan", {
    x: -15.056,
    y: 174.6
  }, "$2.65"), /*#__PURE__*/React.createElement("tspan", {
    x: -15.056,
    y: 194
  }, "$2.61"), /*#__PURE__*/React.createElement("tspan", {
    x: -15.056,
    y: 213.4
  }, "$2.67"), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -15.513,
    y: 232.8
  }, "$2.96"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpcTable);
export default __webpack_public_path__ + "static/media/ppcTable.c37a556c.svg";
export { ForwardRef as ReactComponent };